var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:none;stroke:#5B5B5B;stroke-width:1.3;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "slider") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,0C12.5,0,0,12.5,0,28s12.5,28,28,28s28-12.5,28-28S43.5,0,28,0z M28,54C13.6,54,2,42.4,2,28S13.6,2,28,2 s26,11.6,26,26S42.4,54,28,54z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.3,26.5h-7.7c-0.3,0-0.5-0.2-0.5-0.5v-11c0-0.3,0.2-0.5,0.5-0.5h7.7c0.3,0,0.5,0.2,0.5,0.5v11 C23.8,26.3,23.6,26.5,23.3,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.7,26.5H26.9c-0.3,0-0.6-0.3-0.6-0.6V15.3c0-0.3,0.3-0.6,0.6-0.6h13.8c0.3,0,0.6,0.3,0.6,0.6v10.6 C41.3,26.3,41,26.5,40.7,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.3,41.4h-13c-0.3,0-0.6-0.3-0.6-0.6V30.1c0-0.3,0.3-0.6,0.6-0.6h13c0.3,0,0.6,0.3,0.6,0.6v10.7 C28.9,41.1,28.6,41.4,28.3,41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41,33.6h-9.6c-0.2,0-0.3-0.1-0.3-0.3v-3.5c0-0.2,0.1-0.3,0.3-0.3H41c0.2,0,0.3,0.1,0.3,0.3v3.5 C41.3,33.5,41.2,33.6,41,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.9,41.4h-9.4c-0.2,0-0.4-0.2-0.4-0.4v-5.2c0-0.2,0.2-0.4,0.4-0.4h9.4c0.2,0,0.4,0.2,0.4,0.4V41 C41.3,41.2,41.1,41.4,40.9,41.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/blocks.a488fd7a508297c43ca2beb2f720b6cc.svg";
export { ForwardRef as ReactComponent };